// global.store.js
import { io } from 'socket.io-client';
import insuranceStoreModule from './components/insurance/store';
import product from './components/insurance/slices/product';
import quotation from './components/insurance/slices/quotation';
import { loadState } from './libs/persist';
import benefits from './components/insurance/slices/benefits';
import risk from './components/insurance/slices/risk';
import help from './components/insurance/slices/help';
import auth from './components/insurance/slices/auth';
import comparison from './components/insurance/slices/comparison';
import kyc from './components/newportal/slices/kyc';
import quotations from './components/newportal/slices/quotations';

import invoices from './components/newportal/slices/invoices';
import pagination from './components/newportal/slices/pagination';
import appointment from './components/newportal/slices/appointment';
import valuation from './components/insurance/slices/valuation';

let storeContent = generateStore({
	loading: false,
	show: false,
	chat_id: null,
	selected_chat_user: null,
	socket: null,
	showListReview: false,
	showAddReviews: false,
	product_reviews: [],
	showRenewPolicyModal: false,
	showInvoice: false,
	showAppointmentData: false,
	showReportIncident: false,
	showReportClaim: false,
	// Add session data to your existing store structure
	session_data: {},
	routes: [
		{ icon: 'fa fa-columns', component: 'Dashboard' },
		{ icon: 'fa fa-shopping-cart', component: 'Cart' },
		{
			icon: 'fa fa-file-invoice-dollar',
			component: 'Accounts',
			name: 'Accounts',
		},
		{ icon: 'fa fa-receipt', component: 'Invoice' },
		{
			icon: 'fa fa-exchange-alt',
			component: 'IPFRequests',
			name: 'IPF Requests',
		},
		{ icon: 'fa fa-tag', component: 'UserProducts', name: 'My Policies' },
		{ icon: 'fa fa-file-invoice-dollar', component: 'Claims' },
		{ icon: 'fa fa-quote-right', component: 'Quotations' },
		{
			icon: 'fa fa-users-cog',
			name: 'Profile',
			children: [
				{ component: 'UserProfile', name: 'User Profile' },
				{ component: 'UserKYC', name: 'KYC' },
				{ component: 'UserAssessment', name: 'Assessment' },
			],
			id: 'profile',
		},
		{ icon: 'fa fa-user-tie', component: 'Intermediaries' },
		{ icon: 'fa fa-bullhorn', component: 'Notification' },
		{
			icon: 'fa fa-wallet',
			component: 'TopUpOptions',
			name: 'Top Up Options',
		},
		{ icon: 'fa fa-comments', component: 'Chats' },
	],
	back_ads: [],
	api_key: 'pk_test_Ay8ELm8RjY7GG96YewHNtywy00QkjgOJBo',
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
		// Add session getter to work with existing components expecting $session
		getSessionData: (state) => (key) => {
			// First check in-memory store, then fallback to sessionStorage
			if (state.session_data && state.session_data[key] !== undefined) {
				return state.session_data[key];
			}

			const sessionValue = sessionStorage.getItem(key);
			if (sessionValue === null) return null;

			try {
				return JSON.parse(sessionValue);
			} catch (e) {
				return sessionValue;
			}
		},
	},
	mutations: {
		...storeContent.mutations,
		// Add session mutations
		SET_SESSION_DATA(state, { key, value }) {
			if (!state.session_data) {
				state.session_data = {};
			}
			state.session_data[key] = value;
			// Also persist to sessionStorage
			try {
				sessionStorage.setItem(key, JSON.stringify(value));
			} catch (e) {
				sessionStorage.setItem(key, value);
			}
		},
		SET_SHOW_MAKE_PAYMENT(state, value) {
			state.showMakePayment = value;
		},
		REMOVE_SESSION_DATA(state, key) {
			if (state.session_data) {
				delete state.session_data[key];
			}
			sessionStorage.removeItem(key);
		},
		CLEAR_SESSION_DATA(state) {
			state.session_data = {};
			sessionStorage.clear();
		},
		LOAD_SESSION_DATA(state) {
			// Load existing sessionStorage data into store on app initialization
			if (!state.session_data) {
				state.session_data = {};
			}

			for (let i = 0; i < sessionStorage.length; i++) {
				const key = sessionStorage.key(i);
				const value = sessionStorage.getItem(key);

				try {
					state.session_data[key] = JSON.parse(value);
				} catch (e) {
					state.session_data[key] = value;
				}
			}
		},
	},
	actions: {
		// Add session actions
		setSessionData({ commit }, { key, value }) {
			commit('SET_SESSION_DATA', { key, value });
		},
		removeSessionData({ commit }, key) {
			commit('REMOVE_SESSION_DATA', key);
		},
		clearSessionData({ commit }) {
			commit('CLEAR_SESSION_DATA');
		},
		loadSessionData({ commit }) {
			commit('LOAD_SESSION_DATA');
		},
		showMakePayment({ commit }) {
			commit('SET_SHOW_MAKE_PAYMENT');
		},

		// Your existing actions
		async logOutUser() {
			let res = await api.fetchEndpointSecure(
				{
					resource: 'logout',
					action: 'logout',
					data: {},
				},
				'/client',
			);
		},
		async initializeSocket(ctx) {
			try {
				let chat_endpoint = process.env.VUE_APP_SOCKET_IO;
				const location = window.location.hostname;

				if (location == 'localhost' || location == '127.0.0.1') {
					chat_endpoint = 'https://chat.prod.nexus.ke/';
				} else {
					let apiEnv = location.split('.');
					apiEnv = apiEnv[1];
					chat_endpoint = `https://chat.${apiEnv}.nexus.ke/`;
				}
				// const socket = io(chat_endpoint);
				// ctx.commit('socket',socket)
			} catch (err) {
				throw err;
			}
		},
		async alignBoxToCenter(ctx, payload) {
			await payload.$nextTick();
			let width =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;

			if (width > 768) {
				let white_content =
						document.getElementById('white_content') ||
						document.getElementById('white_content_reg'),
					blue_content =
						document.getElementById('blue_content') ||
						document.getElementById('blue_content_reg');

				if (!white_content || !blue_content) {
					return null;
				}
				let white_height = white_content.offsetHeight;
				let blue_height = blue_content.offsetHeight;

				if (white_height > blue_height) {
					blue_content.style.top = `${(white_height - blue_content) / 2}px`;
				}
			}
		},
	},
	modules: {
		insurance: insuranceStoreModule,
		product,
		quotation,
		benefits,
		risk,
		help,
		auth,
		comparison,
		kyc,
		quotations,
		pagination,
		invoices,
		appointment,
		valuation,
	},
};

export function generateStore(data) {
	let state = {},
		getters = {},
		mutations = {};

	for (const [key, obj] of Object.entries(data)) {
		state[key] = obj;
		getters[key] = (state) => {
			return state[key];
		};
		mutations[key] = (state, content) => {
			state[key] = content;
		};
	}

	return { state, getters, mutations };
}
